import { Component, input } from '@angular/core';
import { RvbSummary } from '../../models/rent-vs-buy.models';
import { RvbFormatPipe } from '../../pipes/rvb-format.pipe';

@Component({
  selector: 'hs-rvb-metric-row',
  standalone: true,
  imports: [RvbFormatPipe],
  template: `
    <div class="metric-row">
      <div class="metric-row__card metric-row__card--buy">
        <div class="metric-row__label">Monthly buy cost</div>
        <div class="metric-row__val metric-row__val--blue">{{ summary().monthlyBuyCost | rvbFormat:'dollar' }}</div>
        <div class="metric-row__sub">P&amp;I + tax + ins + HOA + maint.</div>
      </div>
      <div class="metric-row__card metric-row__card--rent">
        <div class="metric-row__label">Monthly rent (start)</div>
        <div class="metric-row__val metric-row__val--green">{{ summary().monthlyRentStart | rvbFormat:'dollar' }}</div>
        <div class="metric-row__sub">0.8% of home price</div>
      </div>
      <div class="metric-row__card metric-row__card--buy">
        <div class="metric-row__label">Home equity at exit</div>
        <div class="metric-row__val metric-row__val--blue">{{ summary().equityAtExit | rvbFormat:'compact' }}</div>
        <div class="metric-row__sub">After selling costs</div>
      </div>
      <div class="metric-row__card metric-row__card--rent">
        <div class="metric-row__label">Investment portfolio</div>
        <div class="metric-row__val metric-row__val--green">{{ summary().portfolioAtExit | rvbFormat:'compact' }}</div>
        <div class="metric-row__sub">Down pmt + savings invested</div>
      </div>
    </div>
  `,
  styleUrl: './rvb-metric-row.component.scss',
})
export class RvbMetricRowComponent {
  readonly summary = input.required<RvbSummary>();
}
